import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:76
* @route 'https://org.proexpert.app/org/taxonomy/tags'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/taxonomy/tags',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:76
* @route 'https://org.proexpert.app/org/taxonomy/tags'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:76
* @route 'https://org.proexpert.app/org/taxonomy/tags'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:76
* @route 'https://org.proexpert.app/org/taxonomy/tags'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:76
* @route 'https://org.proexpert.app/org/taxonomy/tags'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:87
* @route 'https://org.proexpert.app/org/taxonomy/tags/{tag}'
*/
export const destroy = (args: { tag: string | number } | [tag: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: 'https://org.proexpert.app/org/taxonomy/tags/{tag}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:87
* @route 'https://org.proexpert.app/org/taxonomy/tags/{tag}'
*/
destroy.url = (args: { tag: string | number } | [tag: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tag: args }
    }

    if (Array.isArray(args)) {
        args = {
            tag: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        tag: args.tag,
    }

    return destroy.definition.url
            .replace('{tag}', parsedArgs.tag.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:87
* @route 'https://org.proexpert.app/org/taxonomy/tags/{tag}'
*/
destroy.delete = (args: { tag: string | number } | [tag: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:87
* @route 'https://org.proexpert.app/org/taxonomy/tags/{tag}'
*/
const destroyForm = (args: { tag: string | number } | [tag: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:87
* @route 'https://org.proexpert.app/org/taxonomy/tags/{tag}'
*/
destroyForm.delete = (args: { tag: string | number } | [tag: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const tags = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default tags